import {optionAction, overlayPanelAction} from "../../../../redux/store";
import {useEffect, useRef} from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import callPeerRemoteModule from "../../../../../core/utils/callPeerRemoteModule";


const useMainNavigation = () => {

  const dispatch = useDispatch();
  const scrollbarsRef = useRef();
  const navRef = useRef([]);
  const {currentNavigation, connectMode} = useSelector(state => ({
    currentNavigation: state.optionWindow.currentNavigation,
    connectMode: state.theme.connectMode
  }),shallowEqual);



  const summaryButtonClickHandler = async () => {
    dispatch(optionAction.setCurrentHeader("summary"));
    dispatch(overlayPanelAction.setIsOverlayPanelActive(true));
    dispatch(overlayPanelAction.setOverlayPanelItem("SUMMARY"));

    const peer = await callPeerRemoteModule(connectMode);
    if(peer) {
      peer.conn.sendData("dispatch", { action: "optionAction", func: "setCurrentHeader", payload: "summary"});
      peer?.conn?.sendData("dispatch", { action: "overlayPanelAction", func: "setIsOverlayPanelActive", payload: true });
      peer?.conn?.sendData("dispatch", { action: "overlayPanelAction", func: "setOverlayPanelItem", payload: "SUMMARY" });
    }
  }


  useEffect(() => {
    const navDom = navRef.current.find(item => item.current && item.current.id === `option_${currentNavigation}`);
    if (navDom && navDom.current) {
      const offsetTop = navDom.current.offsetTop > 80 ? navDom.current.offsetTop :0;
      scrollbarsRef.current.view.style.scrollBehavior = "smooth";
      scrollbarsRef.current.scrollTop(offsetTop);
    }
  }, [currentNavigation, navRef]);

  return { summaryButtonClickHandler, scrollbarsRef, navRef }

}

export default useMainNavigation;
